export const DEFAULT_LOCALE = 'EN';

export const LOCALE_OPTIONS = [
  { label: 'EN', value: 'EN' },
  { label: 'HE', value: 'HE' },
];

export const ALLOWED_LOCALES = new Set(LOCALE_OPTIONS.map((o) => o.value));
